var _jsxFileName = "/builds/ccm-innovation/ccm-2.0/address-components/src/components/AddressPicker/SubPremiseModal.js";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Select from 'react-dropdown-select';
import ReactModal from 'react-modal';
import './SubPremiseModal.css';

var SubPremiseModal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubPremiseModal, _Component);

  function SubPremiseModal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      selectedSubPremise: null
    };
    return _this;
  }

  var _proto = SubPremiseModal.prototype;

  _proto.onSubPremiseSelected = function onSubPremiseSelected(selectedSubPremise) {
    if (selectedSubPremise.length === 0) selectedSubPremise = null;
    this.setState({
      selectedSubPremise: selectedSubPremise
    });
  };

  _proto.handleSave = function handleSave() {
    this.props.handleSubPremiseSelected(this.state.selectedSubPremise[0].value);
    this.setState({
      selectedSubPremise: null
    });
  };

  _proto.handleCancel = function handleCancel() {
    this.props.closeModal();
    this.setState({
      selectedSubPremise: null
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        style = _this$props.style,
        isOpen = _this$props.isOpen,
        subPremises = _this$props.subPremises;
    var selectedSubPremise = this.state.selectedSubPremise;
    var modalWidth = style.modalWidth;
    var subPremiseOptions = [];
    subPremises.forEach(function (subPremiseValue) {
      var subPremiseLabel = subPremiseValue;
      if (subPremiseValue.toLowerCase() === 'ofc') subPremiseLabel = 'Office';

      if (subPremiseValue === '') {
        subPremiseValue = 'ofc';
        subPremiseLabel = 'Office';
      }

      subPremiseOptions.push({
        label: subPremiseLabel,
        value: subPremiseValue
      });
    });
    return /*#__PURE__*/React.createElement(ReactModal, {
      isOpen: isOpen,
      style: style,
      className: "sub-premise-modal " + modalWidth,
      overlayClassName: 'sub-premise-modal-overlay',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: 'sub-premise-modal-header-text',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 11
      }
    }, "Please select your Apartment, Suite, Unit, etc. from the list below:"), /*#__PURE__*/React.createElement("br", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement(Select, {
      className: 'sub-premise-modal-select-dropdown',
      placeholder: 'Search Apt / Ste / Unit',
      clearable: true,
      dropdownGap: 0,
      dropdownHandle: false,
      closeOnSelect: true,
      value: selectedSubPremise,
      options: subPremiseOptions,
      onChange: function onChange(newSubPremiseSelected) {
        return _this2.onSubPremiseSelected(newSubPremiseSelected);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("br", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("button", {
      disabled: selectedSubPremise === null,
      className: 'sub-premise-modal-button',
      onClick: function onClick() {
        return _this2.handleSave();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 11
      }
    }, "Save"), /*#__PURE__*/React.createElement("button", {
      className: 'sub-premise-modal-button',
      onClick: function onClick() {
        return _this2.handleCancel();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 11
      }
    }, "Cancel")));
  };

  return SubPremiseModal;
}(Component);

export { SubPremiseModal as default };
SubPremiseModal.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired,
  subPremises: PropTypes.array.isRequired,
  handleSubPremiseSelected: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
} : {};